/**
 * Layout Engine service to get/update layout configuration
 */
import { Injectable } from '@angular/core';
import { BundleCall } from '@ispm-client/modules/aggregator/services';
import {take} from 'rxjs/operators';
import {ILayoutConfigParams} from '@ispm-client/modules/layout-engine/interfaces/layout-config-params.interface';
import {Observable} from 'rxjs/Rx';
import {IspmHttpClient} from '@ispm/core/services/ispm-http-client';
import {selectActiveWorkflow} from '@ispm/workflow/store/workflow-config.selectors';
import {IgenomicsState} from '@ispm/core/interfaces/genomics-state.interface';
import {Store} from '@ngrx/store';
import {IWorkflowRequest} from '@ispm/workflow/interfaces/workflow-request.interface';
import {get} from 'lodash';
import { BrowserCacheService } from "@ispm/core/services/browser-cache.service";
import { of } from 'rxjs/observable/of';


@Injectable()
export class ScreeningService {
  private cahcedResponse: Map<string, any> = new Map();
  constructor(private _bundleCall: BundleCall,
              private _ispmHttpClient: IspmHttpClient,
              private store: Store<IgenomicsState>,
              private browserCacheService: BrowserCacheService) { }

  /**
   * Get the data based on given parameters
   * @param params
   * @param resource
   */
  public getBundle(params: string, resource: string,neededCache:boolean): Observable<any> {
    const dataBindings: Array<any> = [];
    dataBindings.push({
      'queryString': params,
      'targetResource': resource
    });
    if(this.cahcedResponse.get(params)){
      return of(this.cahcedResponse.get(params));
    }
    const bundleData = this._bundleCall.searchCall({ queries: dataBindings}).map(res => {
      const data = get(res[0], ['response', 'entry', '0', 'resource']);
      if (data) {
        if(neededCache) {
          this.cahcedResponse.set(params, data);
        }
        return data;
      }
    });
    return bundleData;
  };

  /**
   * Get specific record else default fallback
   * @param params
   */
  public getCmsConfiguration(params: ILayoutConfigParams,cacheKey:string): Observable<any> {
    params['cacheId'] = this.browserCacheService.getCacheId();
    if(this.cahcedResponse.get(cacheKey)){
      return of(this.cahcedResponse.get(cacheKey));
    }
    const req = this._ispmHttpClient.get('layout/config', params).map(res => {
      if (res && res['resource']) {
        this.cahcedResponse.set(cacheKey, res['resource']);
        return res['resource'];
      }
    });
    return req;
  }

  getLatestRevisionStatus(): Promise<IWorkflowRequest> {
    return this.store.select(selectActiveWorkflow).pipe(take(1)).toPromise();
  }

}
